var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#youtube_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF0302",
  d: "M39.203 10.31a5.03 5.03 0 0 0-3.536-3.56c-3.127-.84-15.627-.84-15.627-.84s-12.5 0-15.628.84a5.03 5.03 0 0 0-3.536 3.56C.04 13.45.04 20 .04 20s0 6.55.836 9.69a5.03 5.03 0 0 0 3.536 3.56c3.128.84 15.628.84 15.628.84s12.5 0 15.627-.84a5.03 5.03 0 0 0 3.536-3.56c.837-3.14.837-9.69.837-9.69s0-6.55-.837-9.69"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M15.949 25.948V14.052L26.403 20z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "youtube_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v40H0z"
})))));
export { SvgYoutube as ReactComponent };
export default __webpack_public_path__ + "static/media/youtube.0533d425.svg";